import { render } from "./ShortForm.vue?vue&type=template&id=15563a55&scoped=true"
import script from "./ShortForm.vue?vue&type=script&lang=js"
export * from "./ShortForm.vue?vue&type=script&lang=js"

import "./ShortForm.vue?vue&type=style&index=0&id=15563a55&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15563a55"]])

export default __exports__